import {
  Component,
  ElementRef,
  inject,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CdkDrag, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfirmDialogComponent } from '../../../../../common/components/confirm.dialog/confirm.dialog.component';
import { CreateEditPlanComponent } from '../create.edit.plan/create.edit.plan.component';
import {
  MatDatepicker,
  MatDatepickerInput,
} from '@angular/material/datepicker';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltip } from '@angular/material/tooltip';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TripPlannerService } from '../../../services/trip.planner.service';
import {
  TripAttraction,
  TripPlan,
  UserTrip,
} from '../../../../shared/models/vititor.trip.storage.command';
import { of, takeUntil, tap } from 'rxjs';
import {
  clone,
  isDeepEqual,
  isEmptyArray,
} from '../../../../../common/utils/object.extensions';
import { VisitorEvent } from '../../../../shared/models/visitor.event';
import { VisitorPlace } from '../../../../shared/models/visitor.place';
import { FancyEventDetailsModalComponent } from '../../../../event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from '../../../../event-calendar/components/event.details.modal/event.details.modal.provider';
import { FancyPlaceDetailsModalComponent } from '../../../../place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { IPlaceDetailsModalData } from '../../../../place-calendar/components/place.details.modal/place.details.modal.provider';
import { IMapMarkerWithCustomData } from '../../../../shared/models/place.marker';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { SocialLoginComponent } from '../../../../shared/components/social.login/social.login.component';
import { ModalService } from '../../../../../common/services/modal/modal.service';
import { GoogleMapComponent } from '../../../../shared/components/google.map/google.map.component';
import { BaseComponent } from '../../../../../common/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { EventTimeService } from '../../../../event-calendar/services/event.time.service';
import { VisitorService } from '../../../../shared/services/visitor.service';
import { SeoService } from '../../../../../common/services/seo.service/seo.service';
import { MediaQueryService } from 'src/app/common/services/media.query/media.query.service';
import { TripPlanListComponent } from '../trip.plan.list/trip.plan.list.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ig-trip-details',
  standalone: true,
  imports: [
    CdkDrag,
    CdkDropList,
    ConfirmDialogComponent,
    CreateEditPlanComponent,
    TripPlanListComponent,
    MatDatepicker,
    MatDatepickerInput,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatMenu,
    MatOption,
    MatSelect,
    MatSlideToggle,
    MatTab,
    MatTabGroup,
    MatTooltip,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './trip.details.component.html',
  styleUrl: './trip.details.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TripDetailsComponent extends BaseComponent implements OnInit {
  tripData: IShareTripModelData;
  currentTrip: UserTrip;
  isEditMode = false;
  selectedItemId: string = null;
  mapMarkers: IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>[] = [];
  isFoldTripTitle = false;
  isDragging = false;
  isShowPlans = true;
  isShowUnSavedChangesConfirm = false;
  isShowDeleteDayConfirm = false;
  isShowDeleteTripConfirms = [];
  isShowDeleteAttractionConfirms = [];
  isDeletingTrip = false;
  newDay: Date = null;
  editDayText: string = null;
  moveToDate = '';
  initTripBeforeEditing: UserTrip = null;

  planForm: FormGroup;
  titleForm: FormGroup;

  planTypes = TripPlannerService.planTypes;
  // planTypes = [
  //   {
  //     type: 'Custom',
  //     textColor: '#878787',
  //     bgColor: '#e9e9e9',
  //     iconColor: '#c6c6c6',
  //     icon: 'star'
  //   }, {
  //     type: 'Flight',
  //     textColor: '#b794f4',
  //     bgColor: '#e6e6fb',
  //     iconColor: '#b8b8fd',
  //     icon: 'flight_takeoff'
  //   }, {
  //     type: 'Train',
  //     textColor: '#ff9494',
  //     bgColor: '#ffe4e4',
  //     iconColor: 'pink',
  //     icon: 'train'
  //   }, {
  //     type: 'Bus',
  //     textColor: '#df7ffb',
  //     bgColor: '#f9e5ff',
  //     iconColor: '#f1c0ff',
  //     icon: 'directions_bus_filled'
  //   }, {
  //     type: 'Subway',
  //     textColor: '#ff9569',
  //     bgColor: '#fdecd9',
  //     iconColor: '#ffbf8c',
  //     icon: 'subway'
  //   }, {
  //     type: 'Taxi / Car',
  //     textColor: '#37a3ff',
  //     bgColor: '#cbe8ff',
  //     iconColor: '#aad5ff',
  //     icon: 'local_taxi'
  //   }, {
  //     type: 'Visit',
  //     textColor: '#50a7c7',
  //     bgColor: '#cfe9f3',
  //     iconColor: '#99d7ee',
  //     icon: 'tour'
  //   }, {
  //     type: 'Explore',
  //     textColor: '#4eb284',
  //     bgColor: '#daebe3',
  //     iconColor: '#bedacd',
  //     icon: 'explore'
  //   }, {
  //     type: 'Stroll',
  //     textColor: '#c0823e',
  //     bgColor: '#ebdbca',
  //     iconColor: '#f3c89a',
  //     icon: 'directions_walk'
  //   }, {
  //     type: 'Wander',
  //     textColor: '#c0823e',
  //     bgColor: '#ebdbca',
  //     iconColor: '#f3c89a',
  //     icon: 'directions_walk'
  //   }, {
  //     type: 'Dine',
  //     textColor: '#668af5',
  //     bgColor: '#dbe4ff',
  //     iconColor: '#c3d2ff',
  //     icon: 'restaurant'
  //   }, {
  //     type: 'Dining',
  //     textColor: '#668af5',
  //     bgColor: '#dbe4ff',
  //     iconColor: '#c3d2ff',
  //     icon: 'restaurant'
  //   }, {
  //     type: 'Breakfast',
  //     textColor: '#02be02',
  //     bgColor: '#ddf5ea',
  //     iconColor: '#8bd78b',
  //     icon: 'fastfood'
  //   }, {
  //     type: 'Lunch',
  //     textColor: '#db9a29',
  //     bgColor: '#ffe7be',
  //     iconColor: '#fbcb77',
  //     icon: 'lunch_dining'
  //   }, {
  //     type: 'Dinner',
  //     textColor: '#ff8f1b',
  //     bgColor: '#f6eca7',
  //     iconColor: '#ffdf53',
  //     icon: 'local_dining'
  //   },];

  @ViewChild(GoogleMapComponent, { static: false })
  googleMap: GoogleMapComponent;
  @ViewChild('daysTabGroup', { static: false }) daysTabGroup: MatTabGroup;
  @ViewChild('createTripLogin', { static: false })
  createTripLogin: SocialLoginComponent;
  @ViewChild('tripTitle', { static: false }) tripTitle: ElementRef;
  @ViewChild('tripContainer', { static: false }) tripContainer: ElementRef;

  isMobile: boolean;
  isShowingMapOnMobile: boolean = false;

  snackBar = inject(MatSnackBar);

  constructor(
    public activatedRoute: ActivatedRoute,
    public tripService: TripPlannerService,
    public timeService: EventTimeService,
    public visitorService: VisitorService,
    public mediaQueryService: MediaQueryService,
    public seoService: SeoService,
    public modalService: ModalService,
    public dialogRef: MatDialogRef<TripDetailsComponent>,
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: IShareTripModelData
  ) {
    super({ activatedRoute });

    this.mediaQueryService.isMobile$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });

    this.tripData = data;

    this.planForm = this._fb.group({
      time: [null, []],
      content: [null, []],
      type: [null, []],
      title: [null, []],
    });
    this.titleForm = this._fb.group({
      title: [null, []],
      note: [null, []],
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.seoService.removeNameIdForUserTrip();
    });
  }

  async ngOnInit() {
    if (this.tripData) {
      this.currentTrip = await this.tripService.getUserSingleTripsV3(
        this.tripData.hubName,
        this.tripData.entireTripId,
        this.tripData.singleTripId
      );
      this.setTripContainerHeight();
      setTimeout(() => {
        this.setMapMarkers(this.currentTrip.days[0]);
      }, 1000);
    }
  }

  showMobileMap(item: number | VisitorPlace | VisitorEvent) {
    this.isShowingMapOnMobile = true;

    // item = number indicates showing map for user trip
    if (typeof item === 'number') {
      // use setTimeout to ait for the map to render
      setTimeout(() => {
        this.setMapMarkers(this.currentTrip.days[item]);
      }, 100);
    }
  }

  setTripContainerHeight(delay: number = 0) {
    // setTimeout(() => {
    //   const rect = this.tripTitle.nativeElement.getBoundingClientRect();
    //   console.log(rect.height);
    //   // this.tripTitle.nativeElement.style.height = `${rect.height}px`;
    //   this.tripContainer.nativeElement.style.height = `calc(100% - ${rect.height + 25}px`;
    // }, delay);
  }

  showDetails(attraction: TripAttraction | VisitorEvent | VisitorPlace) {
    // has startTime means it is an event
    if (attraction['feedType'] === 'event' || attraction['startTime']) {
      this.modalService.show({
        component: FancyEventDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentEvent: attraction['item'] || attraction,
          allEvents: [],
          favCustomEvents: [],
          from: 'itinerary',
        } as IEventDetailsModalData,
      });
    } else {
      this.modalService.show({
        component: FancyPlaceDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentPlace: attraction['item'] || attraction,
          from: 'itinerary',
        } as IPlaceDetailsModalData,
      });
    }
  }

  clickAttraction(attraction: TripAttraction | VisitorPlace | VisitorEvent) {
    const _id = attraction['item']?._id || attraction['_id'];
    // click on the same attraction card twice, show the details modal
    if (this.selectedItemId === _id) {
      this.showDetails(attraction);
      return;
    }

    this.googleMap?.closeInfoWindow();
    this.selectedItemId = _id;

    const marker = this.googleMap.mapMarkerObjs.find(
      (x) => x.getTitle() === _id
    );

    if (attraction['feedType'] === 'event' || attraction['startTime']) {
      this.googleMap.showEventInfoWindow(marker, {
        ...marker,
        data: attraction['item'] || attraction,
      } as IMapMarkerWithCustomData<VisitorEvent>);
    } else {
      this.googleMap.showPlaceInfoWindow(marker, {
        ...marker,
        data: attraction['item'] || attraction,
      } as IMapMarkerWithCustomData<VisitorPlace>);
    }
  }

  markerClick($event) {
    $event.data && this.googleMap.showPlaceInfoWindow();
  }

  setMapMarkers(day?) {
    this.mapMarkers = [];
    this.googleMap && (this.googleMap.directionsResults$ = of(null));

    if (!day) {
      if (!this.currentTrip.days.length) return;
      day = this.currentTrip.days[this.daysTabGroup.selectedIndex];
    }

    this.mapMarkers = [];
    let index = 1;
    let directionLocations: { lat; lng; stopover }[] = [];

    for (const attraction of day.attractions) {
      this.mapMarkers.push({
        position: {
          lat: attraction.item.address?.lat,
          lng: attraction.item.address?.lng,
        },
        options: {
          icon: {
            url: 'https://imgoingcalendar.com/assets/imgs/tp-marker-2.png',
            anchor: new google.maps.Point(0, 0),
            scaledSize: new google.maps.Size(25, 25),
          } as google.maps.Icon,
          zIndex: 10,
          // optimized: true,
        },
        label: {
          text: (index++).toString(),
          fontWeight: 'bold',
        },
        title: attraction.item._id, // use this for showing map info window when clicking on list items, see clickAttraction function
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);

      directionLocations.push({
        lat: attraction.item.address?.lat,
        lng: attraction.item.address?.lng,
        stopover: true,
      });
    }

    console.log('this.mapMarkers', this.mapMarkers);

    if (directionLocations.length > 1) {
      this.googleMap.drawDirectionRoute(
        directionLocations,
        google.maps.TravelMode.DRIVING
      );

      this.googleMap.directionsResults$
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((result) => {
          if (!result) {
            this.snackBar.open(
              'Something went wrong, please try again',
              'Close',
              {
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
                panelClass: 'ig-error-snackbar',
              }
            );
            return;
          }

          if (isEmptyArray(result.routes)) {
            this.snackBar.open(
              'Could not load the direction route, please try again.',
              'Close',
              {
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
                panelClass: 'ig-error-snackbar',
              }
            );
            return;
          }

          // this.directionResults = result;
          let totalDistance = 0,
            totalDuration = 0;
          for (const leg of result.routes[0].legs) {
            totalDistance += leg.distance.value;
            totalDuration += leg.duration.value;
          }
          // this.currentItinerary.travelTime = totalDuration;
          // this.currentItinerary.distance = totalDistance;

          // console.log('travelTime', this.currentItinerary.travelTime);
          // console.log('distance', this.currentItinerary.distance);

          // move map to a little right, as left side has the attraction panel
          // setTimeout(() => {
          //   !this.isMobile && this.googleMap.googleMap.googleMap.panBy(-150, 0);
          // }, 20);
          console.log('directionsResults$', result);
        });
    }

    if (directionLocations.length <= 1) {
      this.googleMap && (this.googleMap.directionsResults$ = of(null));
    }
  }

  addDay() {
    console.log('newDay', this.newDay);
    this.currentTrip.days.push({
      date: this.newDay,
      dateText: this.timeService.getOnlyDisplayDate(this.newDay),
      note: '',
      attractions: [],
    });

    setTimeout(() => {
      this.newDay = null;
      this.daysTabGroup.selectedIndex = this.daysTabGroup._tabs.length - 1;
    });
  }

  dateFilter = (d: Date | null): boolean => {
    return !this.currentTrip.days.some(
      (day) => this.timeService.getOnlyDisplayDate(d) === day.dateText
    );
  };

  editPlan(
    day: any,
    attractionIndex: number,
    planIndex: number,
    type: 'prePlans' | 'postPlans',
    $event: TripPlan
  ) {
    day.attractions[attractionIndex][type][planIndex] = $event;
    this.setTripContainerHeight();
  }

  deletePlan(
    day: any,
    attractionIndex: number,
    planIndex: number,
    type: 'prePlans' | 'postPlans' = 'prePlans'
  ) {
    day.attractions[attractionIndex][type].splice(planIndex, 1);
    this.setTripContainerHeight();
  }

  swapPlan(
    day: any,
    attractionIndex: number,
    planIndex: number,
    type: 'prePlans' | 'postPlans' = 'prePlans'
  ) {
    const upperOne = day.attractions[attractionIndex][type][planIndex];
    day.attractions[attractionIndex][type][planIndex] =
      day.attractions[attractionIndex][type][planIndex + 1];
    day.attractions[attractionIndex][type][planIndex + 1] = upperOne;
  }

  switchDays(index: number) {
    this.setMapMarkers(this.currentTrip.days[index]);
    this.setTripContainerHeight();
  }

  moveDayLeft(dayIndex: number) {
    if (dayIndex <= 0) return;

    const prev = this.currentTrip.days[dayIndex - 1];
    this.currentTrip.days[dayIndex - 1] = this.currentTrip.days[dayIndex];
    this.currentTrip.days[dayIndex] = prev;

    this.daysTabGroup.selectedIndex--;
  }

  moveDayRight(dayIndex: number) {
    if (dayIndex >= this.currentTrip.days.length - 1) return;

    const next = this.currentTrip.days[dayIndex + 1];
    this.currentTrip.days[dayIndex + 1] = this.currentTrip.days[dayIndex];
    this.currentTrip.days[dayIndex] = next;

    this.daysTabGroup.selectedIndex++;
  }

  onAttractionDrop(event, day) {
    // swap pre and post plans
    const prePlansPrev = day.attractions[event.previousIndex].prePlans;
    const postPlansPrev = day.attractions[event.previousIndex].postPlans;
    const prePlansCurr = day.attractions[event.currentIndex].prePlans;
    const postPlansCurr = day.attractions[event.currentIndex].postPlans;

    day.attractions[event.previousIndex].prePlans = prePlansCurr;
    day.attractions[event.previousIndex].postPlans = postPlansCurr;

    day.attractions[event.currentIndex].prePlans = prePlansPrev;
    day.attractions[event.currentIndex].postPlans = postPlansPrev;

    moveItemInArray(day.attractions, event.previousIndex, event.currentIndex);

    this.setMapMarkers(day);
  }

  getPlanStyle(type: string) {
    const plan = this.planTypes.find((x) => x.type === type);
    if (plan) {
      return plan;
    }

    return this.planTypes.find((x) => x.type === 'Custom');
  }

  cancelEdit() {
    this.isEditMode = false;
    this.currentTrip = this.initTripBeforeEditing;
    this.setMapMarkers();
  }

  editOrSave(event: ButtonTriggerEvent) {
    this.isEditMode = !this.isEditMode;

    if (this.isEditMode) {
      this.initTripBeforeEditing = clone(this.currentTrip);
      this.titleForm.get('title').setValue(this.initTripBeforeEditing.title);
    }

    // save
    if (!this.isEditMode) {
      console.log('this.currentTrip', this.currentTrip);

      if (SocialLoginComponent.isUserLoggedIn) {
        this.visitorService
          .saveTrip(this.hubName, this.currentTrip, SocialLoginComponent.userId)
          .subscribe(() => {
            event.success();
          });
      }
    }

    this.setTripContainerHeight();
  }

  getTotalStops(trip: UserTrip) {
    let total = 0;
    for (const day of trip.days) {
      total += day.attractions.length;
    }
    return { total, text: `${total} stop${total > 1 ? 's' : ''}` };
  }

  getDisplayDate(date: Date | string) {
    return this.timeService.getOnlyDisplayDate(date);
  }

  getDeleteAttractionTip(day, attractionIndex) {
    return `Are you sure you want to remove this attraction from the itinerary? All the plans above ${
      attractionIndex === day.attractions.length - 1 ? 'and below' : ''
    } this attraction will be removed too.`;
  }

  deleteAttraction(day, attractionIndex: number) {
    this.rebuildPlanAssociation(day, attractionIndex);
    day.attractions.splice(attractionIndex, 1);
    this.isShowDeleteAttractionConfirms[attractionIndex] = false;

    this.setMapMarkers(day);
  }

  // deleteTrip(index: number) {
  //   this.isDeletingTrip = true;
  //   if (SocialLoginComponent.userId) {
  //     this.visitorService
  //       .deleteTrip(
  //         this.hubName,
  //         SocialLoginComponent.userId,
  //         this.trips[index].id
  //       ).pipe(
  //       finalize(() => {
  //         this.isDeletingTrip = false;
  //         this.closeConfirms();
  //       })
  //     )
  //       .subscribe(async () => {
  //         await this.loadTrips();
  //       });
  //   }
  // }

  closeConfirms() {
    this.isShowDeleteTripConfirms = [];
  }

  deleteDay(dayIndex: number) {
    this.currentTrip.days.splice(dayIndex, 1);
    this.isShowDeleteDayConfirm = false;
  }

  getAvailableDates(day) {
    return this.currentTrip.days.filter((x) => x.dateText !== day.dateText);
  }

  editDateChange() {
    this.editDayText = this.timeService.getOnlyDisplayDate(this.newDay);
  }

  editDay(day, trigger: MatMenuTrigger) {
    console.log(day);
    console.log('this.newDay', this.newDay);
    if (this.newDay) {
      day.date = this.newDay;
      day.dateText = this.timeService.getOnlyDisplayDate(this.newDay);
    }

    this.newDay = null;
    this.editDayText = null;

    trigger.closeMenu();
  }

  editDayNote(day, trigger) {
    day.note = this.titleForm.get('note').value;
    trigger.closeMenu();
  }

  saveMoveDate(day, attractionIndex: number, trigger: MatMenuTrigger) {
    const targetDate = this.currentTrip.days.find(
      (x) => x.dateText === this.moveToDate
    );
    console.log('targetDate', this.moveToDate);
    if (!targetDate) {
      console.log('no targetDate', this.moveToDate);
      return;
    }

    this.rebuildPlanAssociation(day, attractionIndex);

    const attraction = day.attractions[attractionIndex];
    // if the target day (move to this day)'s last attraction has post-plans, set them as the pre-plans of the moving attraction
    if (
      targetDate.attractions.length &&
      targetDate.attractions.last().postPlans.length
    ) {
      attraction.prePlans = [...targetDate.attractions.last().postPlans];
      targetDate.attractions.last().postPlans = [];
    }

    targetDate.attractions.push(attraction);
    day.attractions.splice(attractionIndex, 1);

    this.setMapMarkers(day);
    this.setTripContainerHeight();

    trigger.closeMenu();
  }

  rebuildPlanAssociation(day, attractionIndex) {
    const attraction = day.attractions[attractionIndex];
    // process the moving attraction
    // not last attraction (which only has pre-plans), move its pre-plans to the below attraction
    if (
      attractionIndex !== day.attractions.length - 1 &&
      attraction.prePlans.length
    ) {
      day.attractions[attractionIndex + 1].prePlans = [
        ...attraction.prePlans,
        ...day.attractions[attractionIndex + 1].prePlans,
      ];
      attraction.prePlans = [];
    }

    // last attraction, move its pre/post-plans to the above attraction
    if (
      attractionIndex === day.attractions.length - 1 &&
      day.attractions.length > 1
    ) {
      day.attractions[attractionIndex - 1].postPlans = [
        ...day.attractions[attractionIndex - 1].postPlans,
        ...attraction.prePlans,
        ...attraction.postPlans,
      ];
      attraction.prePlans = [];
      attraction.postPlans = [];
    }

    // Moving the only one attraction in the day will remove all the plans within this day.
    if (
      attractionIndex === day.attractions.length - 1 &&
      day.attractions.length === 1
    ) {
      attraction.prePlans = [];
      attraction.postPlans = [];
    }
  }

  setTripTitle(trigger: MatMenuTrigger) {
    this.currentTrip.title = this.titleForm.get('title').value;
    trigger.closeMenu();

    this.setTripContainerHeight();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.stopPropagation();
    }
  }
}

export interface IShareTripModelData {
  hubName: string;
  entireTripId: string;
  singleTripId: string;
}
